import { render, staticRenderFns } from "./DocLayout.vue?vue&type=template&id=7a0b2f00&scoped=true&"
import script from "./DocLayout.vue?vue&type=script&lang=js&"
export * from "./DocLayout.vue?vue&type=script&lang=js&"
import style0 from "./DocLayout.vue?vue&type=style&index=0&id=7a0b2f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0b2f00",
  null
  
)

export default component.exports